import api from "./axios";
import {
  HotelList,
  HotelType,
  HotelCreateInput,
  HotelOut,
  AdminHotelList,
  AdminHotelCreateInput,
  AdminHotelRow,
  AdminHotelUpdateInput,
  HotelMappingRow,
} from "../types/hotels";

export async function listAdminHotels(params: {
  page?: number;
  per_page?: number;
  type?: HotelType | null;
  company_id?: number | null;
  order_by?: "id" | "type" | "company_name" | "created_at" | null;
  order_dir?: "asc" | "desc" | null;
  q?: string | null;
} = {}) {
  const { data } = await api.get<AdminHotelList>("/hotels/", {
    params: {
      page: params.page ?? 1,
      per_page: params.per_page ?? 20,
      q: params.q?.trim() || null,
      type: params.type ?? null,
      company_id: params.company_id ?? null,
      order_by: params.order_by ?? "id",
      order_dir: params.order_dir ?? "desc",
    },
  });
  return data;
}

export async function createAdminHotel(payload: AdminHotelCreateInput) {
  const { data } = await api.post<AdminHotelRow>("/hotels/", payload);
  return data;
}

export async function updateAdminHotel(hotelId: number, payload: AdminHotelUpdateInput) {
  const { data } = await api.patch<AdminHotelRow>(`/hotels/${hotelId}`, payload);
  return data;
}

export async function deleteAdminHotel(hotelId: number) {
  await api.delete(`/hotels/${hotelId}`);
}

export async function listHotels(
  companyId: number,
  params: { page?: number; per_page?: number; q?: string | null; city?: string | null; type?: HotelType | null; ai_enable?: boolean } = {},
  signal?: AbortSignal,
) {
  const { data } = await api.get<HotelList>(`/companies/${companyId}/hotels`, {
    signal,
    params: {
      page: params.page ?? 1,
      per_page: params.per_page ?? 20,
      q: params.q ?? null,
      city: params.city ?? null,
      type: params.type ?? null,
      ai_enable: params.ai_enable,
    },
  });
  return data;
}


export async function createHotel(companyId: number, body: HotelCreateInput) {
  const { data } = await api.post<HotelOut>(`/companies/${companyId}/hotels`, body);
  return data;
}


export async function listCompanyHotels(company_id: number) {
  const { data } = await api.get(`/companies/${company_id}/hotels`);
  return data;
}

export async function getHotelMapping(hotelId: number) {
  const { data } = await api.get<HotelMappingRow[]>(`/hotels/${hotelId}/mapping`);
  return data;
}

export async function recheckHotelMapping(hotelId: number) {
  const { data } = await api.post<HotelMappingRow[]>(`/hotels/${hotelId}/mapping/recheck`);
  return data;
}

function parseFilenameFromDisposition(value?: string) {
  if (!value) return undefined;

  const utf8Match = value.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const quotedMatch = value.match(/filename="([^"]+)"/i);
  if (quotedMatch?.[1]) {
    return quotedMatch[1];
  }

  const plainMatch = value.match(/filename=([^;]+)/i);
  if (plainMatch?.[1]) {
    return plainMatch[1].trim();
  }

  return undefined;
}

export async function downloadHotelMappingCsv(hotelId: number) {
  const response = await api.get<Blob>(`/hotels/${hotelId}/mapping/csv`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename: parseFilenameFromDisposition(response.headers["content-disposition"]),
  };
}
